module.exports = __webpack_public_path__ + "static/media/close-icon.6b7fe214.svg";